export const italiano = {
    header: {
        logout: "Esci",
        lingua: "Lingua:",
        cambioDitta: "Cambia ditta",
    },
    dataTable: {
        tornaSu: 'Torna su'
    },
    azioni: {
        indietro: 'Indietro',
        conferma: 'Conferma',
        salva: 'Salva',
        aggiungi: 'Aggiungi',
        ricerca: 'Ricerca'
    },
    errori: {
        datiNonValidi: 'Dati non validi'
    },
    home: 'Che cosa vuoi fare?',
    selezionaDitta: "Seleziona la ditta:",
}

export const inglese = {
    header: {
        logout: "Log out",
        lingua: "Language:",
        cambioDitta: "Change company",
    }, 
    dataTable: {
        tornaSu: 'Up'
    },
    azioni: {
        indietro: 'Indietro',
        conferma: 'Conferma',
        salva: 'Salva',
        aggiungi: 'Aggiungi',
        ricerca: 'Ricerca'
    },
    errori: {
        datiNonValidi: 'Dati non validi'
    },
    home: 'Che cosa vuoi fare?',
    selezionaDitta: "Select the company:"
}